// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3NdDe","colBig":"styles_colBig__1hdpb","colSmall":"styles_colSmall__3-7Vd","shopifyNameWrapper":"styles_shopifyNameWrapper__xYfoo"};